export class CountryList {
  
static getAllCurrency= [
            {
                "value": "AED",
                "label": "United Arab Emirates Dirham"
            },
            {
                "value": "AFN",
                "label": "Afghanistan Afghani"
            },
            {
                "value": "ALL",
                "label": "Albania Lek"
            },
            {
                "value": "AMD",
                "label": "Armenia Dram"
            },
            {
                "value": "ANG",
                "label": "Netherlands Antilles Guilder"
            },
            {
                "value": "AOA",
                "label": "Angola Kwanza"
            },
            {
                "value": "ARS",
                "label": "Argentina Peso"
            },
            {
                "value": "AUD",
                "label": "Australia Dollar"
            },
            {
                "value": "AWG",
                "label": "Aruba Guilder"
            },
            {
                "value": "AZN",
                "label": "Azerbaijan Manat"
            },
            {
                "value": "BAM",
                "label": "Bosnia and Herzegovina Convertible Mark"
            },
            {
                "value": "BBD",
                "label": "Barbados Dollar"
            },
            {
                "value": "BDT",
                "label": "Bangladesh Taka"
            },
            {
                "value": "BGN",
                "label": "Bulgaria Lev"
            },
            {
                "value": "BHD",
                "label": "Bahrain Dinar"
            },
            {
                "value": "BIF",
                "label": "Burundi Franc"
            },
            {
                "value": "BMD",
                "label": "Bermuda Dollar"
            },
            {
                "value": "BND",
                "label": "Brunei Darussalam Dollar"
            },
            {
                "value": "BOB",
                "label": "Bolivia Bolíviano"
            },
            {
                "value": "BRL",
                "label": "Brazil Real"
            },
            {
                "value": "BSD",
                "label": "Bahamas Dollar"
            },
            {
                "value": "BTN",
                "label": "Bhutan Ngultrum"
            },
            {
                "value": "BWP",
                "label": "Botswana Pula"
            },
            {
                "value": "BYN",
                "label": "Belarus Ruble"
            },
            {
                "value": "BZD",
                "label": "Belize Dollar"
            },
            {
                "value": "CAD",
                "label": "Canada Dollar"
            },
            {
                "value": "CDF",
                "label": "Congo/Kinshasa Franc"
            },
            {
                "value": "CHF",
                "label": "Switzerland Franc"
            },
            {
                "value": "CLP",
                "label": "Chile Peso"
            },
            {
                "value": "CNY",
                "label": "China Yuan Renminbi"
            },
            {
                "value": "COP",
                "label": "Colombia Peso"
            },
            {
                "value": "CRC",
                "label": "Costa Rica Colon"
            },
            {
                "value": "CUC",
                "label": "Cuba Convertible Peso"
            },
            {
                "value": "CUP",
                "label": "Cuba Peso"
            },
            {
                "value": "CVE",
                "label": "Cape Verde Escudo"
            },
            {
                "value": "CZK",
                "label": "Czech Republic Koruna"
            },
            {
                "value": "DJF",
                "label": "Djibouti Franc"
            },
            {
                "value": "DKK",
                "label": "Denmark Krone"
            },
            {
                "value": "DOP",
                "label": "Dominican Republic Peso"
            },
            {
                "value": "DZD",
                "label": "Algeria Dinar"
            },
            {
                "value": "EGP",
                "label": "Egypt Pound"
            },
            {
                "value": "ERN",
                "label": "Eritrea Nakfa"
            },
            {
                "value": "ETB",
                "label": "Ethiopia Birr"
            },
            {
                "value": "EUR",
                "label": "Euro Member Countries"
            },
            {
                "value": "FJD",
                "label": "Fiji Dollar"
            },
            {
                "value": "FKP",
                "label": "Falkland Islands (Malvinas) Pound"
            },
            {
                "value": "GBP",
                "label": "United Kingdom Pound"
            },
            {
                "value": "GEL",
                "label": "Georgia Lari"
            },
            {
                "value": "GGP",
                "label": "Guernsey Pound"
            },
            {
                "value": "GHS",
                "label": "Ghana Cedi"
            },
            {
                "value": "GIP",
                "label": "Gibraltar Pound"
            },
            {
                "value": "GMD",
                "label": "Gambia Dalasi"
            },
            {
                "value": "GNF",
                "label": "Guinea Franc"
            },
            {
                "value": "GTQ",
                "label": "Guatemala Quetzal"
            },
            {
                "value": "GYD",
                "label": "Guyana Dollar"
            },
            {
                "value": "HKD",
                "label": "Hong Kong Dollar"
            },
            {
                "value": "HNL",
                "label": "Honduras Lempira"
            },
            {
                "value": "HRK",
                "label": "Croatia Kuna"
            },
            {
                "value": "HTG",
                "label": "Haiti Gourde"
            },
            {
                "value": "HUF",
                "label": "Hungary Forint"
            },
            {
                "value": "IDR",
                "label": "Indonesia Rupiah"
            },
            {
                "value": "ILS",
                "label": "Israel Shekel"
            },
            {
                "value": "IMP",
                "label": "Isle of Man Pound"
            },
            {
                "value": "INR",
                "label": "India Rupee"
            },
            {
                "value": "IQD",
                "label": "Iraq Dinar"
            },
            {
                "value": "IRR",
                "label": "Iran Rial"
            },
            {
                "value": "ISK",
                "label": "Iceland Krona"
            },
            {
                "value": "JEP",
                "label": "Jersey Pound"
            },
            {
                "value": "JMD",
                "label": "Jamaica Dollar"
            },
            {
                "value": "JOD",
                "label": "Jordan Dinar"
            },
            {
                "value": "JPY",
                "label": "Japan Yen"
            },
            {
                "value": "KES",
                "label": "Kenya Shilling"
            },
            {
                "value": "KGS",
                "label": "Kyrgyzstan Som"
            },
            {
                "value": "KHR",
                "label": "Cambodia Riel"
            },
            {
                "value": "KMF",
                "label": "Comorian Franc"
            },
            {
                "value": "KPW",
                "label": "Korea (North) Won"
            },
            {
                "value": "KRW",
                "label": "Korea (South) Won"
            },
            {
                "value": "KWD",
                "label": "Kuwait Dinar"
            },
            {
                "value": "KYD",
                "label": "Cayman Islands Dollar"
            },
            {
                "value": "KZT",
                "label": "Kazakhstan Tenge"
            },
            {
                "value": "LAK",
                "label": "Laos Kip"
            },
            {
                "value": "LBP",
                "label": "Lebanon Pound"
            },
            {
                "value": "LKR",
                "label": "Sri Lanka Rupee"
            },
            {
                "value": "LRD",
                "label": "Liberia Dollar"
            },
            {
                "value": "LSL",
                "label": "Lesotho Loti"
            },
            {
                "value": "LYD",
                "label": "Libya Dinar"
            },
            {
                "value": "MAD",
                "label": "Morocco Dirham"
            },
            {
                "value": "MDL",
                "label": "Moldova Leu"
            },
            {
                "value": "MGA",
                "label": "Madagascar Ariary"
            },
            {
                "value": "MKD",
                "label": "Macedonia Denar"
            },
            {
                "value": "MMK",
                "label": "Myanmar (Burma) Kyat"
            },
            {
                "value": "MNT",
                "label": "Mongolia Tughrik"
            },
            {
                "value": "MOP",
                "label": "Macau Pataca"
            },
            {
                "value": "MRU",
                "label": "Mauritania Ouguiya"
            },
            {
                "value": "MUR",
                "label": "Mauritius Rupee"
            },
            {
                "value": "MVR",
                "label": "Maldives (Maldive Islands) Rufiyaa"
            },
            {
                "value": "MWK",
                "label": "Malawi Kwacha"
            },
            {
                "value": "MXN",
                "label": "Mexico Peso"
            },
            {
                "value": "MYR",
                "label": "Malaysia Ringgit"
            },
            {
                "value": "MZN",
                "label": "Mozambique Metical"
            },
            {
                "value": "NAD",
                "label": "Namibia Dollar"
            },
            {
                "value": "NGN",
                "label": "Nigeria Naira"
            },
            {
                "value": "NIO",
                "label": "Nicaragua Cordoba"
            },
            {
                "value": "NOK",
                "label": "Norway Krone"
            },
            {
                "value": "NPR",
                "label": "Nepal Rupee"
            },
            {
                "value": "NZD",
                "label": "New Zealand Dollar"
            },
            {
                "value": "OMR",
                "label": "Oman Rial"
            },
            {
                "value": "PAB",
                "label": "Panama Balboa"
            },
            {
                "value": "PEN",
                "label": "Peru Sol"
            },
            {
                "value": "PGK",
                "label": "Papua New Guinea Kina"
            },
            {
                "value": "PHP",
                "label": "Philippines Peso"
            },
            {
                "value": "PKR",
                "label": "Pakistan Rupee"
            },
            {
                "value": "PLN",
                "label": "Poland Zloty"
            },
            {
                "value": "PYG",
                "label": "Paraguay Guarani"
            },
            {
                "value": "QAR",
                "label": "Qatar Riyal"
            },
            {
                "value": "RON",
                "label": "Romania Leu"
            },
            {
                "value": "RSD",
                "label": "Serbia Dinar"
            },
            {
                "value": "RUB",
                "label": "Russia Ruble"
            },
            {
                "value": "RWF",
                "label": "Rwanda Franc"
            },
            {
                "value": "SAR",
                "label": "Saudi Arabia Riyal"
            },
            {
                "value": "SBD",
                "label": "Solomon Islands Dollar"
            },
            {
                "value": "SCR",
                "label": "Seychelles Rupee"
            },
            {
                "value": "SDG",
                "label": "Sudan Pound"
            },
            {
                "value": "SEK",
                "label": "Sweden Krona"
            },
            {
                "value": "SGD",
                "label": "Singapore Dollar"
            },
            {
                "value": "SHP",
                "label": "Saint Helena Pound"
            },
            {
                "value": "SLL",
                "label": "Sierra Leone Leone"
            },
            {
                "value": "SOS",
                "label": "Somalia Shilling"
            },
            {
                "value": "SPL*",
                "label": "Seborga Luigino"
            },
            {
                "value": "SRD",
                "label": "Suriname Dollar"
            },
            {
                "value": "STN",
                "label": "São Tomé and Príncipe Dobra"
            },
            {
                "value": "SVC",
                "label": "El Salvador Colon"
            },
            {
                "value": "SYP",
                "label": "Syria Pound"
            },
            {
                "value": "SZL",
                "label": "eSwatini Lilangeni"
            },
            {
                "value": "THB",
                "label": "Thailand Baht"
            },
            {
                "value": "TJS",
                "label": "Tajikistan Somoni"
            },
            {
                "value": "TMT",
                "label": "Turkmenistan Manat"
            },
            {
                "value": "TND",
                "label": "Tunisia Dinar"
            },
            {
                "value": "TOP",
                "label": "Tonga Pa'anga"
            },
            {
                "value": "TRY",
                "label": "Turkey Lira"
            },
            {
                "value": "TTD",
                "label": "Trinidad and Tobago Dollar"
            },
            {
                "value": "TVD",
                "label": "Tuvalu Dollar"
            },
            {
                "value": "TWD",
                "label": "Taiwan New Dollar"
            },
            {
                "value": "TZS",
                "label": "Tanzania Shilling"
            },
            {
                "value": "UAH",
                "label": "Ukraine Hryvnia"
            },
            {
                "value": "UGX",
                "label": "Uganda Shilling"
            },
            {
                "value": "USD",
                "label": "United States Dollar"
            },
            {
                "value": "UYU",
                "label": "Uruguay Peso"
            },
            {
                "value": "UZS",
                "label": "Uzbekistan Som"
            },
            {
                "value": "VEF",
                "label": "Venezuela Bolívar"
            },
            {
                "value": "VND",
                "label": "Viet Nam Dong"
            },
            {
                "value": "VUV",
                "label": "Vanuatu Vatu"
            },
            {
                "value": "WST",
                "label": "Samoa Tala"
            },
            {
                "value": "XAF",
                "label": "Communauté Financière Africaine (BEAC) CFA Franc BEAC"
            },
            {
                "value": "XCD",
                "label": "East Caribbean Dollar"
            },
            {
                "value": "XDR",
                "label": "International Monetary Fund (IMF) Special Drawing Rights"
            },
            {
                "value": "XOF",
                "label": "Communauté Financière Africaine (BCEAO) Franc"
            },
            {
                "value": "XPF",
                "label": "Comptoirs Français du Pacifique (CFP) Franc"
            },
            {
                "value": "YER",
                "label": "Yemen Rial"
            },
            {
                "value": "ZAR",
                "label": "South Africa Rand"
            },
            {
                "value": "ZMW",
                "label": "Zambia Kwacha"
            },
            {
                "value": "ZWD",
                "label": "Zimbabwe Dollar"
            }
        ]
    




static getAllList=
[{'value': 'Afghan', 'label': 'Afghan'}, {'value': 'Albanian', 'label': 'Albanian'}, {'value': 'Algerian', 'label': 'Algerian'}, {'value': 'American', 'label': 'American'}, {'value': 'Andorran', 'label': 'Andorran'}, {'value': 'Angolan', 'label': 'Angolan'}, {'value': 'Antiguans', 'label': 'Antiguans'}, {'value': 'Argentinean', 'label': 'Argentinean'}, {'value': 'Armenian', 'label': 'Armenian'}, {'value': 'Australian', 'label': 'Australian'}, {'value': 'Austrian', 'label': 'Austrian'}, {'value': 'Azerbaijani', 'label': 'Azerbaijani'}, {'value': 'Bahamian', 'label': 'Bahamian'}, {'value': 'Bahraini', 'label': 'Bahraini'}, {'value': 'Bangladeshi', 'label': 'Bangladeshi'}, {'value': 'Barbadian', 'label': 'Barbadian'}, {'value': 'Barbudans', 'label': 'Barbudans'}, {'value': 'Batswana', 'label': 'Batswana'}, {'value': 'Belarusian', 'label': 'Belarusian'}, {'value': 'Belgian', 'label': 'Belgian'}, {'value': 'Belizean', 'label': 'Belizean'}, {'value': 'Beninese', 'label': 'Beninese'}, {'value': 'Bhutanese', 'label': 'Bhutanese'}, {'value': 'Bolivian', 'label': 'Bolivian'}, {'value': 'Bosnian', 'label': 'Bosnian'}, {'value': 'Brazilian', 'label': 'Brazilian'}, {'value': 'British', 'label': 'British'}, {'value': 'Bruneian', 'label': 'Bruneian'}, {'value': 'Bulgarian', 'label': 'Bulgarian'}, {'value': 'Burkinabe', 'label': 'Burkinabe'}, {'value': 'Burmese', 'label': 'Burmese'}, {'value': 'Burundian', 'label': 'Burundian'}, {'value': 'Cambodian', 'label': 'Cambodian'}, {'value': 'Cameroonian', 'label': 'Cameroonian'}, {'value': 'Canadian', 'label': 'Canadian'}, {'value': 'Cape Verdean', 'label': 'Cape Verdean'}, {'value': 'Central African', 'label': 'Central African'}, {'value': 'Chadian', 'label': 'Chadian'}, {'value': 'Chilean', 'label': 'Chilean'}, {'value': 'Chinese', 'label': 'Chinese'}, {'value': 'Colombian', 'label': 'Colombian'}, {'value': 'Comoran', 'label': 'Comoran'}, {'value': 'Congolese', 'label': 'Congolese'}, {'value': 'Costa Rican', 'label': 'Costa Rican'}, {'value': 'Croatian', 'label': 'Croatian'}, {'value': 'Cuban', 'label': 'Cuban'}, {'value': 'Cypriot', 'label': 'Cypriot'}, {'value': 'Czech', 'label': 'Czech'}, {'value': 'Danish', 'label': 'Danish'}, {'value': 'Djibouti', 'label': 'Djibouti'}, {'value': 'Dominican', 'label': 'Dominican'}, {'value': 'Dutch', 'label': 'Dutch'}, {'value': 'East Timorese', 'label': 'East Timorese'}, {'value': 'Ecuadorean', 'label': 'Ecuadorean'}, {'value': 'Egyptian', 'label': 'Egyptian'}, {'value': 'Emirian', 'label': 'Emirian'}, {'value': 'Equatorial Guinean', 'label': 'Equatorial Guinean'}, {'value': 'Eritrean', 'label': 'Eritrean'}, {'value': 'Estonian', 'label': 'Estonian'}, {'value': 'Ethiopian', 'label': 'Ethiopian'}, {'value': 'Fijian', 'label': 'Fijian'}, {'value': 'Filipino', 'label': 'Filipino'}, {'value': 'Finnish', 'label': 'Finnish'}, {'value': 'French', 'label': 'French'}, {'value': 'Gabonese', 'label': 'Gabonese'}, {'value': 'Gambian', 'label': 'Gambian'}, {'value': 'Georgian', 'label': 'Georgian'}, {'value': 'German', 'label': 'German'}, {'value': 'Ghanaian', 'label': 'Ghanaian'}, {'value': 'Greek', 'label': 'Greek'}, {'value': 'Grenadian', 'label': 'Grenadian'}, {'value': 'Guatemalan', 'label': 'Guatemalan'}, {'value': 'Guinea-Bissauan', 'label': 'Guinea-Bissauan'}, {'value': 'Guinean', 'label': 'Guinean'}, {'value': 'Guyanese', 'label': 'Guyanese'}, {'value': 'Haitian', 'label': 'Haitian'}, {'value': 'Herzegovinian', 'label': 'Herzegovinian'}, {'value': 'Honduran', 'label': 'Honduran'}, {'value': 'Hungarian', 'label': 'Hungarian'}, {'value': 'I-Kiribati', 'label': 'I-Kiribati'}, {'value': 'Icelander', 'label': 'Icelander'}, {'value': 'Indian', 'label': 'Indian'}, {'value': 'Indonesian', 'label': 'Indonesian'}, {'value': 'Iranian', 'label': 'Iranian'}, {'value': 'Iraqi', 'label': 'Iraqi'}, {'value': 'Irish', 'label': 'Irish'}, {'value': 'Israeli', 'label': 'Israeli'}, {'value': 'Italian', 'label': 'Italian'}, {'value': 'Ivorian', 'label': 'Ivorian'}, {'value': 'Jamaican', 'label': 'Jamaican'}, {'value': 'Japanese', 'label': 'Japanese'}, {'value': 'Jordanian',

'label': 'Jordanian'}, {'value': 'Kazakhstani', 'label': 'Kazakhstani'}, {'value': 'Kenyan', 'label': 'Kenyan'}, {'value': 'Kittian and Nevisian', 'label': 'Kittian and Nevisian'}, {'value': 'Kuwaiti', 'label': 'Kuwaiti'}, {'value': 'Kyrgyz', 'label': 'Kyrgyz'}, {'value': 'Laotian', 'label': 'Laotian'}, {'value': 'Latvian', 'label': 'Latvian'}, {'value': 'Lebanese', 'label': 'Lebanese'}, {'value': 'Liberian', 'label': 'Liberian'}, {'value': 'Libyan', 'label': 'Libyan'}, {'value': 'Liechtensteiner', 'label': 'Liechtensteiner'}, {'value': 'Lithuanian', 'label': 'Lithuanian'}, {'value': 'Luxembourger', 'label': 'Luxembourger'}, {'value': 'Macedonian', 'label': 'Macedonian'}, {'value': 'Malagasy', 'label': 'Malagasy'}, {'value': 'Malawian', 'label': 'Malawian'}, {'value': 'Malaysian', 'label': 'Malaysian'}, {'value': 'Maldivan', 'label': 'Maldivan'}, {'value': 'Malian', 'label': 'Malian'}, {'value': 'Maltese', 'label': 'Maltese'}, {'value': 'Marshallese', 'label': 'Marshallese'}, {'value': 'Mauritanian', 'label': 'Mauritanian'}, {'value': 'Mauritian', 'label': 'Mauritian'}, {'value': 'Mexican', 'label': 'Mexican'}, {'value': 'Micronesian', 'label': 'Micronesian'}, {'value': 'Moldovan', 'label': 'Moldovan'}, {'value': 'Monacan', 'label': 'Monacan'}, {'value': 'Mongolian', 'label': 'Mongolian'}, {'value': 'Moroccan', 'label': 'Moroccan'}, {'value': 'Mosotho', 'label': 'Mosotho'}, {'value': 'Motswana', 'label': 'Motswana'}, {'value': 'Mozambican', 'label': 'Mozambican'}, {'value': 'Namibian', 'label': 'Namibian'}, {'value': 'Nauruan', 'label': 'Nauruan'}, {'value': 'Nepalese', 'label': 'Nepalese'}, {'value': 'New Zealander', 'label': 'New Zealander'}, {'value': 'Nicaraguan', 'label': 'Nicaraguan'}, {'value': 'Nigerian', 'label': 'Nigerian'}, {'value': 'Nigerien', 'label': 'Nigerien'}, {'value': 'North Korean', 'label': 'North Korean'}, {'value': 'Northern Irish', 'label': 'Northern Irish'}, {'value': 'Norwegian', 'label': 'Norwegian'}, {'value': 'Omani', 'label': 'Omani'}, {'value': 'Pakistani', 'label': 'Pakistani'}, {'value': 'Palauan', 'label': 'Palauan'}, {'value': 'Panamanian', 'label': 'Panamanian'}, {'value': 'Papua New Guinean', 'label': 'Papua New Guinean'}, {'value': 'Paraguayan', 'label': 'Paraguayan'}, {'value': 'Peruvian', 'label': 'Peruvian'}, {'value': 'Polish', 'label': 'Polish'}, {'value': 'Portuguese', 'label': 'Portuguese'}, {'value': 'Qatari', 'label': 'Qatari'}, {'value': 'Romanian', 'label': 'Romanian'}, {'value': 'Russian', 'label': 'Russian'}, {'value': 'Rwandan', 'label': 'Rwandan'}, {'value': 'Saint Lucian', 'label': 'Saint Lucian'}, {'value': 'Salvadoran', 'label': 'Salvadoran'}, {'value': 'Samoan', 'label': 'Samoan'}, {'value': 'San Marinese', 'label': 'San Marinese'}, {'value': 'Sao Tomean', 'label': 'Sao Tomean'}, {'value': 'Saudi', 'label': 'Saudi'}, {'value': 'Scottish', 'label': 'Scottish'}, {'value': 'Senegalese', 'label': 'Senegalese'}, {'value': 'Serbian', 'label': 'Serbian'}, {'value': 'Seychellois', 'label': 'Seychellois'}, {'value': 'Sierra Leonean', 'label': 'Sierra Leonean'}, {'value': 'Singaporean', 'label': 'Singaporean'}, {'value': 'Slovakian', 'label': 'Slovakian'}, {'value': 'Slovenian', 'label': 'Slovenian'}, {'value': 'Solomon Islander', 'label': 'Solomon Islander'}, {'value': 'Somali', 'label': 'Somali'}, {'value': 'South African', 'label': 'South African'}, {'value': 'South Korean', 'label': 'South Korean'}, {'value': 'Spanish', 'label': 'Spanish'}, {'value': 'Sri Lankan', 'label': 'Sri Lankan'}, {'value': 'Sudanese', 'label': 'Sudanese'}, {'value': 'Surinamer', 'label': 'Surinamer'}, {'value': 'Swazi', 'label': 'Swazi'}, {'value': 'Swedish', 'label': 'Swedish'}, {'value': 'Swiss', 'label': 'Swiss'}, {'value': 'Syrian', 'label': 'Syrian'}, {'value': 'Taiwanese', 'label': 'Taiwanese'}, {'value': 'Tajik', 'label': 'Tajik'}, {'value': 'Tanzanian', 'label': 'Tanzanian'}, {'value': 'Thai', 'label': 'Thai'}, {'value': 'Togolese', 'label': 'Togolese'}, {'value': 'Tongan', 'label': 'Tongan'}, {'value': 'Trinidadian or Tobagonian', 'label': 'Trinidadian or Tobagonian'}, {'value':

'Tunisian', 'label': 'Tunisian'}, {'value': 'Turkish', 'label': 'Turkish'}, {'value': 'Tuvaluan', 'label': 'Tuvaluan'}, {'value': 'Ugandan', 'label': 'Ugandan'}, {'value': 'Ukrainian', 'label': 'Ukrainian'}, {'value': 'Uruguayan', 'label': 'Uruguayan'}, {'value': 'Uzbekistani', 'label': 'Uzbekistani'}, {'value': 'Venezuelan', 'label': 'Venezuelan'}, {'value': 'Vietnamese', 'label': 'Vietnamese'}, {'value': 'Welsh', 'label': 'Welsh'}, {'value': 'Yemenite', 'label': 'Yemenite'}, {'value': 'Zambian', 'label': 'Zambian'}, {'value': 'Zimbabwean', 'label': 'Zimbabwean'}]
  
static getAllDestination = [{'value': 'Afghanistan ', 'label': 'Afghanistan '}, {'value': 'Albania ', 'label': 'Albania '}, {'value': 'Algeria ', 'label': 'Algeria '}, {'value': 'American Samoa ', 'label': 'American Samoa '}, {'value': 'Andorra ', 'label': 'Andorra '}, {'value': 'Angola ', 'label': 'Angola '}, {'value': 'Anguilla ', 'label': 'Anguilla '}, {'value': 'Antigua & Barbuda ', 'label': 'Antigua & Barbuda '}, {'value': 'Argentina ', 'label': 'Argentina '}, {'value': 'Armenia ', 'label': 'Armenia '}, {'value': 'Aruba ', 'label': 'Aruba '}, {'value': 'Australia ', 'label': 'Australia '}, {'value': 'Austria ', 'label': 'Austria '}, {'value': 'Azerbaijan ', 'label': 'Azerbaijan '}, {'value': 'Bahamas, The ', 'label': 'Bahamas, The '}, {'value': 'Bahrain ', 'label': 'Bahrain '}, {'value': 'Bangladesh ', 'label': 'Bangladesh '}, {'value': 'Barbados ', 'label': 'Barbados '}, {'value': 'Belarus ', 'label': 'Belarus '}, {'value': 'Belgium ', 'label': 'Belgium '}, {'value': 'Belize ', 'label': 'Belize '}, {'value': 'Benin ', 'label': 'Benin '}, {'value': 'Bermuda ', 'label': 'Bermuda '}, {'value': 'Bhutan ', 'label': 'Bhutan '}, {'value': 'Bolivia ', 'label': 'Bolivia '}, {'value': 'Bosnia & Herzegovina ', 'label': 'Bosnia & Herzegovina '}, {'value': 'Botswana ', 'label': 'Botswana '}, {'value': 'Brazil ', 'label': 'Brazil '}, {'value': 'British Virgin Is. ', 'label': 'British Virgin Is. '}, {'value': 'Brunei ', 'label': 'Brunei '}, {'value': 'Bulgaria ', 'label': 'Bulgaria '}, {'value': 'Burkina Faso ', 'label': 'Burkina Faso '}, {'value': 'Burma ', 'label': 'Burma '}, {'value': 'Burundi ', 'label': 'Burundi '}, {'value': 'Cambodia ', 'label': 'Cambodia '}, {'value': 'Cameroon ', 'label': 'Cameroon '}, {'value': 'Canada ', 'label': 'Canada '}, {'value': 'Cape Verde ', 'label': 'Cape Verde '}, {'value': 'Cayman Islands ', 'label': 'Cayman Islands '}, {'value': 'Central African Rep. ', 'label': 'Central African Rep. '}, {'value': 'Chad ', 'label': 'Chad '}, {'value': 'Chile ', 'label': 'Chile '}, {'value': 'China ', 'label': 'China '}, {'value': 'Colombia ', 'label': 'Colombia '}, {'value': 'Comoros ', 'label': 'Comoros '}, {'value': 'Congo, Dem. Rep. ', 'label': 'Congo, Dem. Rep. '}, {'value': 'Congo, Repub. of the ', 'label': 'Congo, Repub. of the '}, {'value': 'Cook Islands ', 'label': 'Cook Islands '}, {'value': 'Costa Rica ', 'label': 'Costa Rica '}, {'value': "Cote d'Ivoire ", 'label': "Cote d'Ivoire "}, {'value': 'Croatia ', 'label': 'Croatia '}, {'value': 'Cuba ', 'label': 'Cuba '}, {'value': 'Cyprus ', 'label': 'Cyprus '}, {'value': 'Czech Republic ', 'label': 'Czech Republic '}, {'value': 'Denmark ', 'label': 'Denmark '}, {'value': 'Djibouti ', 'label': 'Djibouti '}, {'value': 'Dominica ', 'label': 'Dominica '}, {'value': 'Dominican Republic ', 'label': 'Dominican Republic '}, {'value': 'East Timor ', 'label': 'East Timor '}, {'value': 'Ecuador ', 'label': 'Ecuador '}, {'value': 'Egypt ', 'label': 'Egypt '}, {'value': 'El Salvador ', 'label': 'El Salvador '}, {'value': 'Equatorial Guinea ', 'label': 'Equatorial Guinea '}, {'value': 'Eritrea ', 'label': 'Eritrea '}, {'value': 'Estonia ', 'label': 'Estonia '}, {'value': 'Ethiopia ', 'label': 'Ethiopia '}, {'value': 'Faroe Islands ', 'label': 'Faroe Islands '}, {'value': 'Fiji ', 'label': 'Fiji '}, {'value': 'Finland ', 'label': 'Finland '}, {'value': 'France ', 'label': 'France '}, {'value': 'French Guiana ', 'label': 'French Guiana '}, {'value': 'French Polynesia ', 'label': 'French Polynesia '}, {'value': 'Gabon ', 'label': 'Gabon '}, {'value': 'Gambia, The ', 'label': 'Gambia, The '}, {'value': 'Gaza Strip ', 'label': 'Gaza Strip '}, {'value': 'Georgia ', 'label': 'Georgia '}, {'value': 'Germany ', 'label': 'Germany '}, {'value': 'Ghana ', 'label': 'Ghana '}, {'value': 'Gibraltar ', 'label': 'Gibraltar '}, {'value': 'Greece ', 'label': 'Greece '}, {'value': 'Greenland ', 'label': 'Greenland '}, {'value': 'Grenada ', 'label': 'Grenada '}, {'value': 'Guadeloupe ', 'label': 'Guadeloupe '}, {'value': 'Guam ', 'label': 'Guam '}, {'value': 'Guatemala ', 'label': 'Guatemala '}, {'value': 'Guernsey ', 'label': 'Guernsey '}, {'value': 'Guinea ', 'label': 'Guinea '}, {'value': 'Guinea-Bissau ', 'label': 'Guinea-Bissau '}, {'value': 'Guyana ', 'label': 'Guyana '}, {'value': 'Haiti ', 'label': 'Haiti '}, {'value': 'Honduras ', 'label': 'Honduras '}, {'value': 'Hong Kong ', 'label': 'Hong Kong '}, {'value': 'Hungary ', 'label': 'Hungary '}, {'value': 'Iceland ', 'label': 'Iceland '}, {'value': 'India ', 'label': 'India '}, {'value': 'Indonesia ', 'label': 'Indonesia '}, {'value': 'Iran ', 'label': 'Iran '}, {'value': 'Iraq ', 'label': 'Iraq '}, {'value': 'Ireland ', 'label': 'Ireland '}, {'value': 'Isle of Man ', 'label': 'Isle of Man '}, {'value': 'Israel ', 'label': 'Israel '}, {'value': 'Italy ', 'label': 'Italy '}, {'value': 'Jamaica ', 'label': 'Jamaica '}, {'value': 'Japan ', 'label': 'Japan '}, {'value': 'Jersey ', 'label': 'Jersey '}, {'value': 'Jordan ', 'label': 'Jordan '}, {'value': 'Kazakhstan ', 'label': 'Kazakhstan '}, {'value': 'Kenya ', 'label': 'Kenya '}, {'value': 'Kiribati ', 'label': 'Kiribati '}, {'value': 'Korea, North ', 'label': 'Korea, North '}, {'value': 'Korea, South ', 'label': 'Korea, South '}, {'value': 'Kuwait ', 'label': 'Kuwait '}, {'value': 'Kyrgyzstan ', 'label': 'Kyrgyzstan '}, {'value': 'Laos ', 'label': 'Laos '}, {'value': 'Latvia ', 'label': 'Latvia '}, {'value': 'Lebanon ', 'label': 'Lebanon '}, {'value': 'Lesotho ', 'label': 'Lesotho '}, {'value': 'Liberia ', 'label': 'Liberia '}, {'value': 'Libya ', 'label': 'Libya '}, {'value': 'Liechtenstein ', 'label': 'Liechtenstein '}, {'value': 'Lithuania ', 'label': 'Lithuania '}, {'value': 'Luxembourg ', 'label': 'Luxembourg '}, {'value': 'Macau ', 'label': 'Macau '}, {'value': 'Macedonia ', 'label': 'Macedonia '}, {'value': 'Madagascar ', 'label': 'Madagascar '}, {'value': 'Malawi ', 'label': 'Malawi '}, {'value': 'Malaysia ', 'label': 'Malaysia '}, {'value': 'Maldives ', 'label': 'Maldives '}, {'value': 'Mali ', 'label': 'Mali '}, {'value': 'Malta ', 'label': 'Malta '}, {'value': 'Marshall Islands ', 'label': 'Marshall Islands '}, {'value': 'Martinique ', 'label': 'Martinique '}, {'value': 'Mauritania ', 'label': 'Mauritania '}, {'value': 'Mauritius ', 'label': 'Mauritius '}, {'value': 'Mayotte ', 'label': 'Mayotte '}, {'value': 'Mexico ', 'label': 'Mexico '}, {'value': 'Micronesia, Fed. St. ', 'label': 'Micronesia, Fed. St. '}, {'value': 'Moldova ', 'label': 'Moldova '}, {'value': 'Monaco ', 'label': 'Monaco '}, {'value': 'Mongolia ', 'label': 'Mongolia '}, {'value': 'Montserrat ', 'label': 'Montserrat '}, {'value': 'Morocco ', 'label': 'Morocco '}, {'value': 'Mozambique ', 'label': 'Mozambique '}, {'value': 'Namibia ', 'label': 'Namibia '}, {'value': 'Nauru ', 'label': 'Nauru '}, {'value': 'Nepal ', 'label': 'Nepal '}, {'value': 'Netherlands ', 'label': 'Netherlands '}, {'value': 'Netherlands Antilles ', 'label': 'Netherlands Antilles '}, {'value': 'New Caledonia ', 'label': 'New Caledonia '}, {'value': 'New Zealand ', 'label': 'New Zealand '}, {'value': 'Nicaragua ', 'label': 'Nicaragua '}, {'value': 'Niger ', 'label': 'Niger '}, {'value': 'Nigeria ', 'label': 'Nigeria '}, {'value': 'N. Mariana Islands ', 'label': 'N. Mariana Islands '}, {'value': 'Norway ', 'label': 'Norway '}, {'value': 'Oman ', 'label': 'Oman '}, {'value': 'Pakistan ', 'label': 'Pakistan '}, {'value': 'Palau ', 'label': 'Palau '}, {'value': 'Panama ', 'label': 'Panama '}, {'value': 'Papua New Guinea ', 'label': 'Papua New Guinea '}, {'value': 'Paraguay ', 'label': 'Paraguay '}, {'value': 'Peru ', 'label': 'Peru '}, {'value': 'Philippines ', 'label': 'Philippines '}, {'value': 'Poland ', 'label': 'Poland '}, {'value': 'Portugal ', 'label': 'Portugal '}, {'value': 'Puerto Rico ', 'label': 'Puerto Rico '}, {'value': 'Qatar ', 'label': 'Qatar '}, {'value': 'Reunion ', 'label': 'Reunion '}, {'value': 'Romania ', 'label': 'Romania '}, {'value': 'Russia ', 'label': 'Russia '}, {'value': 'Rwanda ', 'label': 'Rwanda '}, {'value': 'Saint Helena ', 'label': 'Saint Helena '}, {'value': 'Saint Kitts & Nevis ', 'label': 'Saint Kitts & Nevis '}, {'value': 'Saint Lucia ', 'label': 'Saint Lucia '}, {'value': 'St Pierre & Miquelon ', 'label': 'St Pierre & Miquelon '}, {'value': 'Saint Vincent and the Grenadines ', 'label': 'Saint Vincent and the Grenadines '}, {'value': 'Samoa ', 'label': 'Samoa '}, {'value': 'San Marino ', 'label': 'San Marino '}, {'value': 'Sao Tome & Principe ', 'label': 'Sao Tome & Principe '}, {'value': 'Saudi Arabia ', 'label': 'Saudi Arabia '}, {'value': 'Senegal ', 'label': 'Senegal '}, {'value': 'Serbia ', 'label': 'Serbia '}, {'value': 'Seychelles ', 'label': 'Seychelles '}, {'value': 'Sierra Leone ', 'label': 'Sierra Leone '}, {'value': 'Singapore ', 'label': 'Singapore '}, {'value': 'Slovakia ', 'label': 'Slovakia '}, {'value': 'Slovenia ', 'label': 'Slovenia '}, {'value': 'Solomon Islands ', 'label': 'Solomon Islands '}, {'value': 'Somalia ', 'label': 'Somalia '}, {'value': 'South Africa ', 'label': 'South Africa '}, {'value': 'Spain ', 'label': 'Spain '}, {'value': 'Sri Lanka ', 'label': 'Sri Lanka '}, {'value': 'Sudan ', 'label': 'Sudan '}, {'value': 'Suriname ', 'label': 'Suriname '}, {'value': 'Swaziland ', 'label': 'Swaziland '}, {'value': 'Sweden ', 'label': 'Sweden '}, {'value': 'Switzerland ', 'label': 'Switzerland '}, {'value': 'Syria ', 'label': 'Syria '}, {'value': 'Taiwan ', 'label': 'Taiwan '}, {'value': 'Tajikistan ', 'label': 'Tajikistan '}, {'value': 'Tanzania ', 'label': 'Tanzania '}, {'value': 'Thailand ', 'label': 'Thailand '}, {'value': 'Togo ', 'label': 'Togo '}, {'value': 'Tonga ', 'label': 'Tonga '}, {'value': 'Trinidad & Tobago ', 'label': 'Trinidad & Tobago '}, {'value': 'Tunisia ', 'label': 'Tunisia '}, {'value': 'Turkey ', 'label': 'Turkey '}, {'value': 'Turkmenistan ', 'label': 'Turkmenistan '}, {'value': 'Turks & Caicos Is ', 'label': 'Turks & Caicos Is '}, {'value': 'Tuvalu ', 'label': 'Tuvalu '}, {'value': 'Uganda ', 'label': 'Uganda '}, {'value': 'Ukraine ', 'label': 'Ukraine '}, {'value': 'United Arab Emirates ', 'label': 'United Arab Emirates '}, {'value': 'United Kingdom ', 'label': 'United Kingdom '}, {'value': 'United States ', 'label': 'United States '}, {'value': 'Uruguay ', 'label': 'Uruguay '}, {'value': 'Uzbekistan ', 'label': 'Uzbekistan '}, {'value': 'Vanuatu ', 'label': 'Vanuatu '}, {'value': 'Venezuela ', 'label': 'Venezuela '}, {'value': 'Vietnam ', 'label': 'Vietnam '}, {'value': 'Virgin Islands ', 'label': 'Virgin Islands '}, {'value': 'Wallis and Futuna ', 'label': 'Wallis and Futuna '}, {'value': 'West Bank ', 'label': 'West Bank '}, {'value': 'Western Sahara ', 'label': 'Western Sahara '}, {'value': 'Yemen ', 'label': 'Yemen '}, {'value': 'Zambia ', 'label': 'Zambia '}, {'value': 'Zimbabwe', 'label': 'Zimbabwe'}]
}